import PropTypes from 'prop-types';

import { inventorySourceTypes } from '../constants';
import InventorySourcePropType from './inventory-source';

export default PropTypes.shape({
  warehouseGroupName: PropTypes.string,
  inventorySourceType: PropTypes.oneOf([
    inventorySourceTypes.none,
    inventorySourceTypes.native,
    inventorySourceTypes.store,
    inventorySourceTypes.integration,
  ]),
  sellerInventoryPartnerId: PropTypes.string,
  warehouses: PropTypes.arrayOf(InventorySourcePropType),
});
